import React from 'react';
import Carousel from 'nuka-carousel';


//CORE COMPONENTS
import styled from 'styled-components';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerVerticalAlignment,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper';

//STYLE
import { Text, TextAppearance, TextAlignment, } from '../../../components-core/packages/components-core/dist/text';

//ICONS
import { ChevronLeft } from '../../../components-core/packages/icons-core/dist/ChevronLeft/index';
import { ChevronRight } from '../../../components-core/packages/icons-core/dist/ChevronRight/index';


const Divider = styled.hr`
	margin: 0;
	border: 0;
	height: 2px;
    background-color: #DFE4E8;
    width: 24px;
`;

const Photo = styled.div`
    height: 200px;
    width: 200px;
    border-radius: 100%;
    background-color: #DFE4E8;
    margin-right: 24px;
    @media screen and (max-width: 768px) {
        height: 0px;
        width: 0px;
        margin-right: 0px;
    }
`;

const ArrowButton = styled.div`
    cursor: pointer;
    padding: 24px 8px 24px 8px;
    border: 1px solid #dfe4e8;
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 
        0 
        ${props => props.right ? '6rem' : '0px'} 
        0 
        ${props => props.left ? '6rem' : '0px'}
`;

class Testimonial extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedIndex: 0
        }
    }

    renderDescription(item) {
        return (
            <Container 
                horizontalAlign={{[Breakpoints.b560]: ContainerHorizontalAlignment.center}} 
                wrap={ContainerWrap.always}
                padding={{top: ContainerPadding.dynamic0120}}
            >
                <Container 
                    horizontalAlign={item.isPhoto ? ContainerHorizontalAlignment.flexStart : ContainerHorizontalAlignment.center}
                    padding={{ bottom: ContainerPadding.dynamic0050}}
                >
                    <Divider />
                </Container>
                <Text 
                    appearance={TextAppearance.copy0200}
                    textAlign={item.isPhoto ? TextAlignment.left : TextAlignment.center}
                    bold
                >
                    {item.name}
                </Text>
                <Text 
                    appearance={TextAppearance.copy0200}
                    textAlign={item.isPhoto ? TextAlignment.left : TextAlignment.center}
                >
                    {item.job}
                </Text>
            </Container>
        )
    }

    renderSliderPage(item) {
        const globalPadding = {
            [Breakpoints.b1920]: ContainerPadding.grid008,
            [Breakpoints.b1600]: ContainerPadding.grid007,
            [Breakpoints.b1280]: ContainerPadding.grid006,
            [Breakpoints.b960]: ContainerPadding.grid005,
            [Breakpoints.default]: ContainerPadding.grid002
        }

        const containerPadding = {
            left: globalPadding,
            right: globalPadding,
            bottom: ContainerPadding.dynamic0200,
            top: ContainerPadding.dynamic0200
        }

        return (
            <Container padding={containerPadding}>
                <Container 
                    wrap={ContainerWrap.never} 
                    horizontalAlign={ContainerHorizontalAlignment.center} 
                    verticalAlign={ContainerVerticalAlignment.center}
                >
                    {item.isPhoto ? <Photo /> : <div />}
                    <Container wrap={ContainerWrap.always}>
                        <Text 
                            appearance={TextAppearance.headline0350}
                            textAlign={item.isPhoto ? TextAlignment.left : TextAlignment.center}
                        >
                            {item.title}
                        </Text>
                        {this.renderDescription(item)}
                    </Container>
                </Container>
            </Container>
        )
    }

    renderData() {
        const allData = dummyData(this.props);
        let newData = [];
        allData.forEach(item => {
            if (item.title) {
                newData.push(item)
            }
        });
        
        return newData.map(item => this.renderSliderPage(item))
    }

    render() {
        return (
            <Container stretchContent={true}>
                <Carousel 
                    edgeEasing={'easeQuadOut'}
                    renderCenterLeftControls={({ previousSlide }) => (
                        <BreakpointWrapper min={Breakpoints.b960}>
                            <ArrowButton onClick={previousSlide} left>
                                <ChevronLeft/>
                            </ArrowButton>
                        </BreakpointWrapper>
                    )}
                    renderCenterRightControls={({ nextSlide }) => (
                        <BreakpointWrapper  min={Breakpoints.b960}>
                            <ArrowButton onClick={nextSlide} right>
                                <ChevronRight/>
                            </ArrowButton>
                        </BreakpointWrapper>
                    )}
                >
                    {this.renderData()}
                </Carousel>
            </Container>
        )
    }
}

export default Testimonial;


const dummyData = (props) => [
    { 
        title: props.custom,
        name: props.custom4,
        job: props.custom8,
        isPhoto: false
    },
    { 
        title: props.custom1,
        name: props.custom5,
        job: props.custom9,
        isPhoto: false
    },
    { 
        title: props.custom2,
        name: props.custom6,
        job: props.custom10,
        isPhoto: false
    },
    { 
        title: props.custom3,
        name: props.custom7,
        job: props.custom11,
        isPhoto: false
    },
]